import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "controller-wrapper" };
const _hoisted_2 = { class: "top" };
const _hoisted_3 = { class: "area2" };
import { onMounted, ref, useSlots, } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubControllerTemplate',
    setup(__props) {
        // sub controller의 틀
        const slots = useSlots();
        const data = ref({
            titleCss: 'title-wrapper',
            filterToolsCss: 'filter-tools',
            // slot이 있는 지 여부
            hasTitleSlot: true,
            hasToolsSlot: true,
        });
        const getProperCss = () => {
            if (data.value.hasTitleSlot && data.value.hasToolsSlot) {
                return;
            }
            if (data.value.hasTitleSlot) {
                data.value.titleCss = 'only-title-wrapper';
            }
            if (data.value.hasToolsSlot) {
                data.value.filterToolsCss = 'only-filter-tools';
            }
        };
        onMounted(() => {
            const { titleSlot, toolsSlot } = slots;
            data.value.hasTitleSlot = !!titleSlot;
            data.value.hasToolsSlot = !!toolsSlot;
            getProperCss();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" area1 title slot (상단 영역) "),
                    (data.value.hasTitleSlot)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["area1 sub-title-text", data.value.titleCss])
                        }, [
                            _renderSlot(_ctx.$slots, "titleSlot", {}, () => [
                                _cache[0] || (_cache[0] = _createTextVNode(" [titleSlot] "))
                            ])
                        ], 2 /* CLASS */))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" area2 우상단 영역 "),
                    _createElementVNode("div", _hoisted_3, [
                        _renderSlot(_ctx.$slots, "area2")
                    ])
                ]),
                _createCommentVNode(" area3 tool slot (하단 영역) "),
                (data.value.hasToolsSlot)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["area3", data.value.filterToolsCss])
                    }, [
                        _renderSlot(_ctx.$slots, "toolsSlot", {}, () => [
                            _cache[1] || (_cache[1] = _createTextVNode(" [toolsSlot] "))
                        ])
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
